<template>
  <div class="search">
    <h2 class="text-center">Ricerca sentenze</h2>
    <div class="row m-0">
      <p class="col-6 text-right mb-0">Sentenze totali di merito:</p> 
      <b class="text-primary col-6 text-left">{{ formatNumberSentenze(numeroSentenze.diMerito) }}</b>
      
      <p class="col-6 text-right">Sentenze totali amministrative:</p>
      <b class="text-success col-6 text-left">{{ formatNumberSentenze(numeroSentenze.amministrative) }}</b>
    </div>

    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>

    <b-card class="m-md-4 px-md-5 px-sm-0 border-0">
      <b-input-group class="px-md-5 px-sm-0">
        <b-input-group-prepend>
          <b-input-group-text>
            <font-awesome-icon icon="keyboard" />
          </b-input-group-text>
        </b-input-group-prepend>
        <b-form-input id="input-query" class="text-center" v-model="form.query" @keyup.enter.prevent="searchNew()"
          placeholder="Cerca una sentenza..."></b-form-input>
        <b-input-group-append>
          <b-button id="info-search-text" variant="outline-info">
            <font-awesome-icon icon="question" />
          </b-button>
          <b-button variant="outline-success" @click.prevent="searchNew()">
            <font-awesome-icon icon="search" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-popover target="info-search-text" triggers="hover" placement="bottom">
        <template v-slot:title><b>Sintassi di ricerca</b></template>
        <i>parola</i> (cerca una o più parole slegate tra loro)<br />
        <i>=parola</i> (cerca una parola esatta)<br />
        <i>-parola</i> (rimuove una parola dalla ricerca)<br />
        <i>"frase"</i> (cerca la frase esatta)<br />
        <i>pa*</i> (cerca tutte le parole che iniziano con pa)
      </b-popover>

    </b-card>

    <b-container fluid>

      <!-- SEARCH RESULTS -->
      <b-row class="justify-content-end" v-if="(results.diMerito.records && results.diMerito.records.length) || (results.amministrative.records && results.amministrative.records.length)">
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <font-awesome-icon icon="sort-amount-down-alt" />
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="ordinamento" :options="data.ordinamento" v-model="form.ordinamento"
              @change="searchNew()">
            </b-form-select>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row v-if="(results.diMerito.records && results.diMerito.records.length) || (results.amministrative.records && results.amministrative.records.length)">
        <b-col>
          <b-tabs content-class="mt-3" align="center" v-model="activeTab">
            <b-tab>
              <template #title> <!-- Overriding the title prop -->
                <span class="bg-primary text-white px-3 py-2 rounded-top d-inline-block">
                  Sentenze di MERITO<br>
                  <b>{{ results.diMerito.totalNum }} risultati</b>
                </span>
              </template>

              <div class="mb-2 text-right">
                <b-button v-b-toggle.ricerca-avanzata-di-merito variant="outline-secondary">
                  <span class="d-none d-sm-inline">Opzioni avanzate</span>
                  <font-awesome-icon icon="angle-double-down" />
                </b-button>
              </div>

              <!-- FILTRI RICERCA -->
              <b-collapse id="ricerca-avanzata-di-merito" class="text-left px-md-5 px-sm-0 mt-4">
                <!-- TRIBUNALE -->
                <b-row>
                  <b-col sm="3">
                    <label for="tribunale">ORGANO GIUDIZIARIO:</label>
                  </b-col>
                  <b-col sm="9">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="gavel" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-select id="tribunale" v-model="formDiMerito.tribunale">
                        <template v-slot:first>
                          <option :value="``">Qualsiasi</option>
                        </template>
                        <option v-for="trib of data.tribunali" :key="trib.key" :value="trib.key">{{ trib.value }}</option>
                      </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- MATERIA -->
                <b-row>
                  <b-col sm="3">
                    <label for="materia">MATERIA:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select id="materia_1" :options="data.materie1" @change="changeMateria1"
                      v-model="filterMaterie.liv1">
                      <template v-slot:first>
                        <option :value="``">Qualsiasi</option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col sm="3">
                    <b-form-select id="materia_2" :options="data.materie2" @change="changeMateria2"
                      v-model="filterMaterie.liv2">
                      <template v-slot:first>
                        <option :value="filterMaterie.liv1">Qualsiasi</option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="book" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-select id="materia" :options="data.materie" v-model="formDiMerito.materia">
                        <template v-slot:first>
                          <option :value="filterMaterie.liv2 + `*`">Qualsiasi</option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- NUMERO e ANNO SENTENZA -->
                <b-row>
                  <b-col sm="3">
                    <label for="numero_sentenza">NUMERO SENTENZA:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="hashtag" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="numero_sentenza" v-model="formDiMerito.numero_sentenza" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col sm="3">
                    <label for="anno_sentenza">ANNO SENTENZA:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="calendar-day" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="anno_sentenza" v-model="formDiMerito.anno_sentenza" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- NUMERO e ANNO R.G. -->
                <b-row>
                  <b-col sm="3">
                    <label for=".numero_rg">NUMERO R.G.:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="hashtag" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="numero_rg" v-model="formDiMerito.numero_rg" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col sm="3">
                    <label for="anno_rg">ANNO R.G.:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="calendar-day" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="anno_rg" v-model="formDiMerito.anno_rg" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- NOME e CF GIUDICE -->
                <b-row>
                  <b-col sm="3">
                    <label for="nome_giudice">NOME GIUDICE:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="user-graduate" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="nome_giudice" v-model="formDiMerito.nome_giudice" type="text"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col sm="3">
                    <label for="cf_giudice">CF GIUDICE:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="address-card" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="cf_giudice" v-model="formDiMerito.cf_giudice" type="text"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" class="text-right">
                    <b-button @click="pulisciFiltriDiMerito()" variant="outline-danger">
                      <font-awesome-icon icon="broom" /> Pulisci ricerca
                    </b-button>
                    <b-button @click="searchNewDiMerito()" variant="outline-success">
                      <font-awesome-icon icon="search" /> Filtra
                    </b-button>
                  </b-col>
                </b-row>
              </b-collapse>

              <!-- NEWSLETTER -->
              <b-row>
                <b-col>
                  <b-jumbotron class="p-3" lead="Vuoi rimanere aggiornato sulle nuove sentenze pubblicate?">
                    <router-link
                      :to="{ name: 'Newsletter', params: { materia: formDiMerito.materia, tribunale: formDiMerito.tribunale, testo: form.query } }">
                      <b-button variant="outline-info">
                        RICEVI AGGIORNAMENTI SETTIMANALI PER QUESTA RICERCA
                      </b-button>
                    </router-link>
                    <b-button id="info-newsletter">
                      <font-awesome-icon icon="question" />
                    </b-button>
                    <b-popover target="info-newsletter" triggers="hover" placement="bottom">
                      <template v-slot:title>
                        Selezionando il Tribunale e la materia di tuo interesse riceverai una mail settimanale con le ultime
                        sentenze pubblicate al riguardo
                      </template>
                    </b-popover>
                  </b-jumbotron>
                </b-col>
              </b-row>

              <!-- RISULTATI RICERCA -->
              <h4 v-if="results.diMerito.records && !results.diMerito.records.length">Nessun risultato trovato!</h4>
              <h5 v-if="results.diMerito.records && results.diMerito.records.length">Trovati <b>{{ results.diMerito.totalNum }}</b> risultati</h5>
              <b-list-group v-if="results.diMerito.records">
                <result-di-merito v-for="(result, index) in results.diMerito.records" :key="result.id_atto" :sentenza="result" :index="index"
                  :filters="{ ...formDiMerito, ...form }">
                </result-di-merito>

                <infinite-loading @infinite="infiniteHandlerDiMerito" ref="infiniteLoading">
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
              </b-list-group>
            </b-tab>
            <b-tab>
              <template #title> <!-- Overriding the title prop -->
                <span class="bg-success text-white px-3 py-2 rounded-top d-inline-block">
                  Sentenze AMMINISTRATIVE<br>
                  <b>{{ results.amministrative.totalNum }} risultati</b>
                </span>
              </template>

              <div class="mb-2 text-right">
                <b-button v-b-toggle.ricerca-avanzata-amministrative variant="outline-secondary">
                  <span class="d-none d-sm-inline">Opzioni avanzate</span>
                  <font-awesome-icon icon="angle-double-down" />
                </b-button>
              </div>
              
              <!-- FILTRI RICERCA -->
              <b-collapse id="ricerca-avanzata-amministrative" class="text-left px-md-5 px-sm-0 mt-4">
                <!-- SEDE -->
                <b-row>
                  <b-col sm="3">
                    <label for="sede">SEDE:</label>
                  </b-col>
                  <b-col sm="9">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="gavel" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-select id="sede" v-model="formAmministrative.sede">
                        <template v-slot:first>
                          <option :value="``">Qualsiasi</option>
                        </template>
                        <option v-for="trib of data.sediAmministrative" :key="trib.key" :value="trib.key">{{ trib.value }}</option>
                      </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- NUMERO e ANNO PROVVEDIMENTO -->
                <b-row>
                  <b-col sm="3">
                    <label for="numero_provvedimento">NUMERO PROVVEDIMENTO:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="hashtag" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="numero_provvedimento" v-model="formAmministrative.numero_provvedimento" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col sm="3">
                    <label for="anno_provvedimento">ANNO PROVVEDIMENTO:</label>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <font-awesome-icon icon="calendar-day" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="anno_provvedimento" v-model="formAmministrative.anno_provvedimento" type="number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" class="text-right">
                    <b-button @click="pulisciFiltriAmministrative()" variant="outline-danger">
                      <font-awesome-icon icon="broom" /> Pulisci ricerca
                    </b-button>
                    <b-button @click="searchNewAmministrative()" variant="outline-success">
                      <font-awesome-icon icon="search" /> Filtra
                    </b-button>
                  </b-col>
                </b-row>
              </b-collapse>

              <!-- NEWSLETTER -->
              <b-row>
                <b-col>
                  <b-jumbotron class="p-3" lead="Vuoi rimanere aggiornato sulle nuove sentenze pubblicate?">
                    <router-link
                      :to="{ name: 'NewsletterAmministrative', params: { sede: formAmministrative.sede, testo: form.query } }">
                      <b-button variant="outline-info">
                        RICEVI AGGIORNAMENTI SETTIMANALI PER QUESTA RICERCA
                      </b-button>
                    </router-link>
                    <b-button id="info-newsletter">
                      <font-awesome-icon icon="question" />
                    </b-button>
                    <b-popover target="info-newsletter" triggers="hover" placement="bottom">
                      <template v-slot:title>
                        Selezionando la sede di tuo interesse riceverai una mail settimanale con le ultime
                        sentenze pubblicate al riguardo
                      </template>
                    </b-popover>
                  </b-jumbotron>
                </b-col>
              </b-row>

              <!-- RISULTATI RICERCA -->
              <h4 v-if="results.amministrative.records && !results.amministrative.records.length">Nessun risultato trovato!</h4>
              <h5 v-if="results.amministrative.records && results.amministrative.records.length">Trovati <b>{{ results.amministrative.totalNum }}</b> risultati</h5>
              <b-list-group v-if="results.amministrative.records">
                <result-amministrative v-for="(result, index) in results.amministrative.records" :key="result.id_atto" :sentenza="result" :index="index"
                  :filters="{ ...formAmministrative, ...form }">
                </result-amministrative>

                <infinite-loading @infinite="infiniteHandlerAmministrative" ref="infiniteLoading">
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
              </b-list-group>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>

      <!--
      <hr />
      <b-row class="pt-1 sfondo-giustup">
        <b-col class="col-sm-3 embed-responsive embed-responsive-16by9 mx-auto">
          <youtube video-id="6o3bg_1GPhQ" :player-vars="{ autoplay: 1, loop: 1, rel: 0 }" mute="true"
            player-width="400" player-height="225"></youtube>
        </b-col>
      </b-row>
      -->
      <!-- COMMENTI E MASSIME -->
      <!--
      <b-row class="pt-3 sfondo-giustup text-body" v-if="!records">
        <b-col cols="12">
          <h5 class="font-weight-bold" style="color: white">MASSIME E COMMENTI ALLE SENTENZE</h5>
        </b-col>
      </b-row>
      <b-row class="sfondo-giustup text-body" v-for="commento in commenti" :key="commento.id" v-if="!records">
        <b-col sm="3"></b-col>
        <b-col sm="6" style="font-size: 14px;">
          <commento :input="commento" :showCommenta="true" :showTitoloSentenza="true" :showVisualizzazioni="true">
          </commento>
        </b-col>
      </b-row>
      -->
    </b-container>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import ResultDiMerito from './ResultDiMerito.vue'
import ResultAmministrative from './ResultAmministrative.vue';
import Commento from '../Sentenza/Commento.vue';
import api from '../../services/search.js'
import service from '../../services/service.js'

export default {
  name: 'search',
  components: { ResultDiMerito, ResultAmministrative, Commento, InfiniteLoading, Loading },
  data() {
    return {
      form: {
        query: '',
        ordinamento: 'data'
      },
      formDiMerito: {
        tribunale: '',
        materia: '*',
        numero_sentenza: '',
        anno_sentenza: '',
        numero_rg: '',
        anno_rg: '',
        nome_giudice: '',
        cf_giudice: '',
        page: 1
      },
      filterMaterie: {
        liv1: '',
        liv2: '',
      },
      formAmministrative: {
        sede: '',
        numero_provvedimento: '',
        anno_provvedimento: '',
        page: 1
      },
      loading: 0,
      results: {
        diMerito: {
          records: null,
          totalNum: "...",
        },
        amministrative: {
          records: null,
          totalNum: "...",
        }
      },
      data: {
        tribunali: [],
        materie: [],
        materie1: [],
        materie2: [],
        sediAmministrative: [],
        ordinamento: [
          {
            value: 'data',
            text: 'Data'
          },
          {
            value: 'attinenza',
            text: 'Attinenza'
          }
        ]
      },
      commenti: [],
      numeroSentenze: {
        diMerito: '',
        amministrative: ''
      },
      activeTab: 0
    }
  },
  methods: {
    formatNumberSentenze(value) {
      return new Intl.NumberFormat('it-IT').format(value);
    },
    async checkLogged() {
      let data = await service.execute('get', 'oauth');
      return data;
    },
    async searchNew() {
      await Promise.all([
        this.searchNewDiMerito(),
        this.searchNewAmministrative()
      ]);

      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
    async searchNewDiMerito() {
      this.formDiMerito.page = 1;
      this.results.diMerito.records = [];
      await this.searchDiMerito();
    },
    async searchNewAmministrative() {
      this.formAmministrative.page = 1;
      this.results.amministrative.records = [];
      await this.searchAmministrative();
    },
    // Esegue search ma avanzando di pagina
    async searchDiMerito() {
      this.loading++;
      let data = [];

      try {
        data = await api.searchDiMerito({ ...this.formDiMerito, ...this.form });
      }
      catch (e) {
        alert("Errore durante la ricerca!");
        console.log(e);
      }
      this.results.diMerito.totalNum = data.totalNum;

      this.results.diMerito.records.push(...data.sentenze);

      this.formDiMerito.page += 1;
      this.loading--;
      return data.sentenze.length;
    },
    infiniteHandlerDiMerito($state) {
      if (this.results.diMerito.records.length) {
        this.searchDiMerito().then((res) => {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
      else {
        $state.complete();
      }
    },
    // Esegue search ma avanzando di pagina
    async searchAmministrative() {
      this.loading++;
      let data = [];

      try {
        data = await api.searchAmministrative({ ...this.formAmministrative, ...this.form });
      }
      catch (e) {
        alert("Errore durante la ricerca!");
        console.log(e);
      }
      this.results.amministrative.totalNum = data.totalNum;

      this.results.amministrative.records.push(...data.sentenze);

      this.formAmministrative.page += 1;
      this.loading--;
      return data.sentenze.length;
    },
    infiniteHandlerAmministrative($state) {
      if (this.results.amministrative.records.length) {
        this.searchAmministrative().then((res) => {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
      else {
        $state.complete();
      }
    },
    changeMateria1(value) {
      // clean old second level to avoid sending it as a filter
      this.filterMaterie.liv2 = '';
      api.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie2 = data;
        // update the default value of materia2 to be "Qualsiasi"
        this.filterMaterie.liv2 = value;
        // update the default value of materia to be "Qualsiasi"
        this.formDiMerito.materia = value + '*';
      });
    },
    changeMateria2(value) {
      api.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie = data;
        // update the default value of materia to be "Qualsiasi"
        this.formDiMerito.materia = value + '*';
      });
    },
    pulisciFiltriDiMerito() {
      this.formDiMerito.tribunale = '';
      this.formDiMerito.materia = '*';
      this.formDiMerito.numero_sentenza = '';
      this.formDiMerito.anno_sentenza = '';
      this.formDiMerito.numero_rg = '';
      this.formDiMerito.anno_rg = '';
      this.formDiMerito.nome_giudice = '';
      this.formDiMerito.cf_giudice = '';
      this.filterMaterie.liv1 = '';
      this.filterMaterie.liv2 = '';
    },
    pulisciFiltriAmministrative() {
      this.formAmministrative.sede = '';
      this.formAmministrative.numero_provvedimento = '*';
      this.formAmministrative.anno_provvedimento = '';
    },
    async getCommenti() {
      this.commenti = await service.execute('get', 'commento');
    },
    async getNumeroSentenze() {
      this.numeroSentenze = await service.execute('get', 'cercasentenze/numero');
    }
  },

  async created() {
    if (!(await this.checkLogged())) {
      this.$router.push({ name: "Home"})
    }
    let data = await api.getTribunali();
    this.data.tribunali = data;

    data = await api.getMaterie(this.filterMaterie);
    this.data.materie1 = data;

    data = await api.getSediAmministrative();
    this.data.sediAmministrative = data;
    

    this.getCommenti();
    this.getNumeroSentenze();
    this.$parent._data.loaded = true;
      // this.$router.push({ name: "Home"}  )
  },
  watch: {
    activeTab(newIndex) {
      localStorage.setItem('my-active-tab', newIndex)
    }
  },
  mounted() {
    const saved = localStorage.getItem('my-active-tab')
    if (saved !== null) {
      this.activeTab = Number(saved)
    }
  }
}
</script>

<style>
label {
  line-height: 38px;
}

.selected {
  background-color: yellow;
}

.sfondo-giustup {
  background-color: #008bc0;
}

:root {
  /* aggiunta */
  --primary-rgb: 0, 123, 255;
  --success-rgb: 40, 167, 69;
}

.nav-tabs .nav-link:not(.active) span.bg-primary {
  background-color: rgba(var(--primary-rgb), 0.6) !important;
}
.nav-tabs .nav-link:not(.active) span.bg-success {
  background-color: rgba(var(--success-rgb), 0.6) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Search/Search.vue